import React, { useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import MobTable from '../components/MobTable'
import moment from 'moment'
import MemberBadge from '../models/MemberBadge'
import Palette from '../Palette'
import Badge from '../models/Badge'

function MemberBadgePage({ memberId }) {
    const [badgeData, setBadgeData] = useState([])
    const [allBadges, setAllBadges] = useState([])
    const [loading, setLoading] = useState(true)

    const fetchBadges = async () => {
        try {
            setLoading(true)

            const badgeModel = new Badge()
            const memberBadgeModel = new MemberBadge()

            const badgesData = await badgeModel.getActive()
            console.log('✅ All Badges:', badgesData)
            setAllBadges(badgesData)

            const memberBadges = await memberBadgeModel.getByMemberID(memberId)
            console.log('🏅 Member Badges:', memberBadges)
            setBadgeData(memberBadges || [])
        } catch (e) {
            console.error('❌ Error fetching badge data:', e)
            setBadgeData([])
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (memberId) fetchBadges()
    }, [memberId])

    const combinedBadges = useMemo(() => {
        return badgeData.map((mb) => {
            const badgeInfo = allBadges.find((b) => String(b.id) === String(mb.badge_id)) || {}
            return {
                ...mb,
                label: badgeInfo.label || `Badge ID: ${mb.badge_id}`,
                icon_url: badgeInfo.icon_url || 'https://via.placeholder.com/40',
            }
        })
    }, [badgeData, allBadges])

    const isBadgeActive = (badge) => {
        if (!badge.date_start || !badge.date_end) return false
        const now = moment()
        const startDate = moment(badge.date_start)
        const endDate = moment(badge.date_end)
        return now.isBetween(startDate, endDate, null, '[]')
    }

    const columns = useMemo(
        () => [
            {
                Header: <p style={{ fontSize: '0.7em' }}>Lencana</p>,
                accessor: 'label',
                Cell: ({ row }) => {
                    const badge = row.original
                    return (
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <img
                                src={badge.icon_url}
                                alt={badge.label}
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    objectFit: 'cover',
                                    marginRight: '10px',
                                    border: `2px solid ${Palette.SECONDARY}`,
                                }}
                                onError={(e) => {
                                    e.target.onerror = null
                                    e.target.src = 'https://via.placeholder.com/40'
                                }}
                            />
                            <p style={{ fontSize: '0.7em' }}>{badge.label}</p>
                        </div>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Status</p>,
                accessor: 'status',
                Cell: ({ row }) => {
                    const badge = row.original
                    const active = isBadgeActive(badge)
                    return (
                        <p
                            style={{
                                fontSize: '0.7em',
                                color: active ? Palette.SUCCESS : Palette.SECONDARY,
                                fontWeight: 'bold',
                            }}
                        >
                            {active ? 'AKTIF' : 'TIDAK AKTIF'}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Tanggal Mulai</p>,
                accessor: 'date_start',
                Cell: ({ row }) => {
                    const value = row.original.date_start
                    return (
                        <p style={{ fontSize: '0.7em' }}>
                            {value ? moment(value).format('DD MMM YYYY') : '-'}
                        </p>
                    )
                },
            },
            {
                Header: <p style={{ fontSize: '0.7em' }}>Tanggal Berakhir</p>,
                accessor: 'date_end',
                Cell: ({ row }) => {
                    const value = row.original.date_end
                    return (
                        <p style={{ fontSize: '0.7em' }}>
                            {value ? moment(value).format('DD MMM YYYY') : '-'}
                        </p>
                    )
                },
            },
        ],
        [],
    )

    if (loading) {
        return (
            <Row style={{ marginBottom: 15 }}>
                <Col>
                    <p style={{ textAlign: 'center', marginTop: '20px' }}>Memuat data lencana...</p>
                </Col>
            </Row>
        )
    }

    return (
        <Row>
            <Col>
                {combinedBadges.length > 0 ? (
                    <MobTable
                        columns={columns}
                        data={combinedBadges}
                        interactionsLabelStyles={{ fontSize: '0.7em' }}
                    />
                ) : (
                    <p
                        style={{
                            textAlign: 'start',
                        }}
                    >
                        Anda belum memiliki lencana.
                    </p>
                )}
            </Col>
        </Row>
    )
}

export default MemberBadgePage
